@import "./subcomponents/dashboard-tab-view/dashboard-tab-view.scss";
@import "./subcomponents/dashboard-tab-view/dashboard-widgets/dashboard-widgets.scss";
@import "./subcomponents/dashboard-tab-view/dashboard-products/dashboard-products-list/dashboard-products-list.scss";
@import "node_modules/@se/web-ui/styles/_se-variable.scss";

@import "../../../styles/global.scss";
@import "../../../styles/variables.scss";
//@import '../../../styles/mixins/index.scss';

:host(:focus) {
  outline: none !important;
}

.hidden {
  display: none;
}

.filters {
  flex-basis: 36%;
}

.search-tab {
  &__country-results-label {
    cursor: pointer;
  }

  &__country-results-input {
    cursor: pointer;
    color: var(--qds-theme-signature-color-default, #008a16);
    --se-success: var(--qds-theme-signature-color-default, #008a16);
  }
}

se-pagination {
  /*will apply when web-ui PR /IoT/web-ui/pull/389 is merged*/
  text-align: center;
}

.results__list-of-results {
  display: flex;
  flex-direction: column;
  padding: 12px 0;

  &.padding-top-none {
    padding: 0;
  }

  @media (min-width: $uiaas-tablet) {
    flex-direction: row;
  }
}

.results__list-of-results-product-catalog {
  @extend .results__list-of-results;
  padding: 18px 16px;
}

.results__list-of-results-horizontal {
  display: flex;
  flex-direction: column;
}

.filters__section {
  width: 100%;
  @media (min-width: $uiaas-tablet) {
    width: 36%;
    min-width: 250px;
  }
}

.filters__section-horizontal {
  width: 100%;
  margin-top: 10px;
  background-color: #ffffff;
}

::slotted([slot="filters-placeholder"]) {
  width: 100%;
  @media (min-width: $uiaas-tablet) {
    width: 36%;
  }
}

.filters__container-horizontal {
  background-color: #ffffff;
  margin-left: 32px;
}

.filtration__mobile {
  margin-bottom: 20px;
}

.results-container {
  display: inherit;
}

.offsite-widget-v2-grid,
.conversational-search-grid {
  grid-column: 1 / -1;
}

@-moz-document url-prefix() {
  .offsite-widget-v2-grid,
  .conversational-search-grid.conversational-search {
    margin-right: 0; // Fix for firefox
  }
}

.conversational-search {
  @media (min-width: $uiaas-tablet) {
    margin-right: 20px;
  }
}

.results__section {
  width: 100%;

  &.has-simple-chips {
    display: flex;
    flex-direction: column;
  }
}

.results__section--results-only {
  width: 100%;
}

.only-your-country {
  @media (max-width: $uiaas-tablet) {
    margin-bottom: 20px;
  }
  @media (min-width: $uiaas-tablet) {
    margin-right: 20px;
  }
}

.se-block-grid {
  --se-block-color-background: transparent;
}

.grid-cointainer {
  display: grid;

  @media (min-width: 1150px) {
    grid-template-columns: repeat(auto-fit, 270px) !important;
  }
  grid-column-gap: 20px;
  overflow: hidden !important;
}

.grid-container {
  grid-auto-flow: dense;
  row-gap: 8px;
}

// support for mozilla
@-moz-document url-prefix() {
  #grid-container {
    display: grid;
    column-gap: 20px;
    grid-auto-flow: dense;
    row-gap: 20px;
    width: 98%;
    overflow: hidden !important;

    @media (min-width: 1213px) {
      grid-template-columns: repeat(auto-fit, 262px) !important;
    }
  }
}

.results-loading__container {
  width: 100%;
  height: 50px;
  position: relative;
  @media (min-width: $uiaas-tablet) {
    height: 200px;
  }
}

.filter-chip {
  margin-left: -8px;
  margin-right: 8px;
}

.readonly-chip {
  margin-right: auto;
}

.filter-chips-container {
  margin-top: 40px;
  margin-bottom: 10px;
  max-width: 1200px;
  width: 80%;
  min-height: 50px;
  display: block;
}

.empty-filters-container {
  height: 30px;
}

.results__menu {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}

.results__menu-product-catalog {
  @extend .results__menu;
  margin-top: -11px;
}

.search-tab__results-sorting-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  grid-column: 1/-1;
}

.search-tab__results-sorting {
  display: block;
  margin-bottom: 6px;
  margin-right: 20px;
  margin-top: -5px;

  @media (max-width: $uiaas-tablet) {
    margin: 0;
    margin-bottom: 20px;
    width: 100%;
  }
}

.search-tab__number-of-results {
  display: none;
  flex-grow: 1;
  font-size: 14px;
  line-height: 18px;
  margin-top: 1px;
  max-width: 75%;

  @media (min-width: $uiaas-tablet) {
    display: flex;
  }
}

.search-tab__number-of-results--hidden {
  display: none;
}

.product-catalog-chip-tooltip-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.chips-view {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 4px;

  &__element {
    display: flex;
    align-items: center;
    border: 1px solid $se-true-black;
    border-radius: 20px;
    margin: 0 12px 12px 0;
    padding: 0 8px 0 12px;
    height: 32px;

    se-icon {
      margin-top: 6px;
    }
  }
}

.results-loading__spinner-color {
  // override spinner color by defining custom --alternative-se-life-green color in the global.scss file
  --se-primary: var(--qds-theme-signature-color-default, #008a16);
}

.before-first-result-products-tab {
  width: 100%;

  @media (min-width: $uiaas-tablet) {
    margin-top: 35px;
  }
}
.eol-result-list {
  @media (min-width: $uiaas-tablet) {
    margin-right: 8px;
  }
}
.grid-list-switch {
  display: none;
  @media (min-width: $uiaas-tablet) {
    display: flex;
    justify-content: flex-end;
    margin-right: 8px;
  }
}
slot[name="prodcut-recommendation-widget"]:empty {
  display: none;
}
